import React from 'react';

export default function DesenhoInfoScreen({ onNavigate }) {
  return (
    <div className="container2 public-page-shell">
      <header className="header public-header">
        <div className="public-header-content">
          <nav className="public-top-nav" aria-label="Navegação pública">
            <button type="button" className="public-top-link" onClick={() => onNavigate('login')}>
              Login
            </button>
            <button type="button" className="public-top-link" onClick={() => onNavigate('curso')}>
              Curso
            </button>
            <button type="button" className="public-top-link active">
              Desenho
            </button>
          </nav>

          <h1 className="public-main-logo">
            <b className="bold">INK</b>
            <b className="rodriguez">RODRIGUEZ</b>
          </h1>
        </div>
      </header>

      <div className="container public-main-container">
        <section className="public-screen-section">
          <div className="public-screen-header">
            <span className="public-kicker">INKRODRIGUEZ</span>
            <h2 className="public-screen-title">Curso de desenho com base forte.</h2>
            <p className="public-screen-subtitle">
              Essas aulas foram pensadas para quem quer realmente entender desenho e não apenas copiar.
            </p>
          </div>

          <div className="public-metrics-grid">
            <div className="public-metric-card"><strong>12</strong><span>Aulas progressivas</span></div>
            <div className="public-metric-card"><strong>3D</strong><span>Formas e volume</span></div>
            <div className="public-metric-card"><strong>PF</strong><span>1, 2 e 3 pontos de fuga</span></div>
            <div className="public-metric-card"><strong>Final</strong><span>Ilustração completa</span></div>
          </div>

          <div className="public-screen-content">
            <section className="public-content-section">
              <h3>🚀 A proposta das aulas</h3>
              <p className="public-content-text">
                Essas aulas foram pensadas para quem quer realmente entender desenho e não apenas copiar.
                A ideia é construir uma base sólida, com progressão lógica, indo do simples ao complexo.

                {'\n\n'}

                Você vai aprender a construir desenhos com formas geométricas, linha do horizonte,
                profundidade e perspectiva até chegar em uma ilustração final forte.
              </p>
            </section>

            <section className="public-content-section">
              <h3>📚 O que você vai aprender</h3>
              <ul className="public-bullet-list">
                <li>Aula 1 — Enxergando desenho em formas simples</li>
                <li>Aula 2 — Cubo como base da construção</li>
                <li>Aula 3 — Cilindro, esfera e cone na prática</li>
                <li>Aula 4 — Girando formas no espaço</li>
                <li>Aula 5 — Linha do horizonte</li>
                <li>Aula 6 — Leitura visual: cima, baixo e profundidade</li>
                <li>Aula 7 — Perspectiva com 1 ponto de fuga</li>
                <li>Aula 8 — Aplicando 1 ponto em cenário</li>
                <li>Aula 9 — Perspectiva com 2 pontos de fuga</li>
                <li>Aula 10 — Cena com 2 pontos de fuga</li>
                <li>Aula 11 — Perspectiva com 3 pontos de fuga</li>
                <li>Aula 12 — Ilustração final</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>📝 Acompanhamento do aluno</h3>
              <ul className="public-bullet-list">
                <li>Provas ao longo do curso</li>
                <li>Exercícios práticos baseados nas aulas</li>
                <li>Atividades para reforçar a construção e a perspectiva</li>
                <li>Evolução pensada do simples ao complexo</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>🎯 Correção e suporte</h3>
              <ul className="public-bullet-list">
                <li>Você enviará suas ilustrações para análise</li>
                <li>Feedback sobre sua construção e perspectiva</li>
                <li>Resolução de dúvidas individuais</li>
                <li>Acompanhamento para destravar erros e evoluir com direção</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>🧠 Como será a progressão</h3>
              <ul className="public-bullet-list">
                <li>Etapa 1: Controle de traço e percepção visual</li>
                <li>Etapa 2: Formas planas e formas tridimensionais</li>
                <li>Etapa 3: Objetos simples em diferentes ângulos</li>
                <li>Etapa 4: Perspectiva e encaixe</li>
                <li>Etapa 5: Estrutura e articulações</li>
                <li>Etapa 6: Formas orgânicas e seres vivos</li>
                <li>Etapa 7: Humanos, mãos, poses e personagens</li>
                <li>Etapa 8: Ilustração final com linha do horizonte e ponto de fuga</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>🔥 Pra quem é esse curso?</h3>
              <ul className="public-bullet-list">
                <li>Pra quem acha que “não nasceu com dom”</li>
                <li>Pra quem trava em perspectiva</li>
                <li>Pra quem se perde tentando criar um desenho</li>
                <li>Pra quem quer aprender do zero com lógica</li>
                <li>Pra quem quer base forte para qualquer estilo</li>
              </ul>
            </section>

            <section className="public-content-section">
              <h3>Quero saber mais</h3>

              <form className="public-interest-form" onSubmit={(e) => e.preventDefault()}>
                <div className="lead-field">
                  <label htmlFor="leadNome">Nome</label>
                  <input id="leadNome" type="text" placeholder="Seu nome" />
                </div>

                <div className="lead-field">
                  <label htmlFor="leadWhatsapp">Whatsapp</label>
                  <input id="leadWhatsapp" type="text" placeholder="Seu WhatsApp" />
                </div>

                <div className="lead-field">
                  <label htmlFor="leadMotivo">Por que você quer iniciar no curso?</label>
                  <input id="leadMotivo" type="text" placeholder="Me conta seu objetivo" />
                </div>

                <a
                  href="https://wa.me/5524993087471"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary btn-full"
                >
                  Falar no WhatsApp
                </a>
              </form>
            </section>
          </div>

          <p className="public-copyright">
            © 2025 INKRODRIGUEZ. Todos os direitos reservados.
          </p>
        </section>
      </div>
    </div>
  );
}